(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lichcards-facet-groups"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.lcFacetGroups) return;
  const parameter = 'filter.p.product_type';
  // Lichcards 04-09-2026 (audit punt 4): uitgebreid van 11 naar 21 groepen. Eerste naam = wat de klant ziet;
  // de rest zijn bestaande producttypes die daaronder vallen. Producttypes zelf blijven ongewijzigd.
  const groups = [
    ['Booster Box', 'Boosterbox', 'Pokémon Display', 'Yugioh Display', 'Yu-Gi-Oh! Booster Box', 'Digimon Booster Boxes', 'Dragon Ball Super Booster Boxes', 'Flesh And Blood Booster Boxes', 'Lorcana Booster Boxes', 'One Piece Booster Boxes', 'Cardfight!! Vanguard Booster Box', 'Final Fantasy Booster Box', 'Star Wars Unlimited Display', 'Weiβ Schwarz Booster Boxes'],
    ['Booster Pack', 'Boosterpack', 'Pokémon Booster', 'Yugioh Booster', 'Magic Booster', 'Digimon Booster', 'Dragon Ball Super Boosters', 'Flesh And Blood Booster', 'Lorcana Booster', 'One Piece Booster', 'Cardfight!! Vanguard Booster', 'Final Fantasy Booster', 'Gundam Booster', 'Riftbound Booster', 'Star Wars Unlimited Booster', 'Sleeved Booster Pack', 'Theme Booster Pack'],
    ['Elite Trainer Box', 'Pokémon Elite Trainer Boxes'],
    ['Starter Deck', 'Pokémon Starter Deck', 'Magic Starter Deck', 'Digimon Starter Decks', 'Dragon Ball Super Starter Decks', 'Lorcana Starter Decks', 'Star Wars Unlimited Starter Decks', 'Starter Kit', 'Starter Pack', 'Pokémon Theme Deck', 'Magic Intropack'],
    ['Structure Deck', 'Yugioh Structure Deck'],
    ['Challenger Deck', 'Challenger Decks'],
    ['Commander Deck', 'Commander Decks'],
    ['Preconstructed Deck', 'One Piece Preconstructed Decks', 'Flesh And Blood Preconstructed Decks', 'Riftbound Champion Decks'],
    ['Prerelease Box', 'Star Wars Unlimited Prerelease Boxes', 'Final Fantasy Pre-Release Kit'],
    ['Collection Box', 'Pokémon Collection Box', 'Pokémon Box Set', 'Special Box', 'Special Goods Set', 'Premium Card Collection', 'Legendary Collection', 'Anniversary set', 'Lorcana Gift Set', 'Riftbound Box Sets'],
    ['Bundle', 'Magic Fatpack'],
    ['Tin', 'Tins', 'Pokémon Tins'],
    ['Blister', 'Pokémon Blisters'],
    ['Deckbox', 'DeckBoxes'],
    ['Sleeves', 'Hoesjes'],
    ['Binder', 'Albums', 'Portfolio', 'Ringband'],
    ['Dobbelstenen', 'Dice'],
    ['Pocket Pages', 'Pages voor in een ringband'],
    ['Graded kaarten', 'Beckett Graded Kaarten Engels', 'Beckett Graded Kaarten Japans', 'CGC Graded Kaarten Engels', 'PSA Graded Kaarten Engels', 'PSA Graded Kaarten Japans'],
    ['Losse kaarten', 'Pokémon Single', 'Magic Single', 'Yugioh Single', 'One Piece Single', 'Lorcana Single', 'Digimon Single', 'Dragon Ball Super Singles', 'Flesh And Blood Single', 'Gundam Card Game Single', 'Gundam Try Age Single', 'Medabots Single', 'Riftbound Single', 'Weiss Schwarz Single', 'Sports Cards Single', 'Cardfight!! Vanguard Single', 'Final Fantasy Single', 'Disney Trading Card', 'Common', 'Uncommon', 'Rare', 'Mythic Rare', 'Secret Rare', 'Super Rare', 'Leader'],
    ['Promo', 'Promo Pack', 'One Piece Promo Products', 'Yugioh Promo Products', 'Dragon Ball Super Special Packs'],
  ];
  const boardGameTypes = [
    { value: 'Bordspel', labels: { nl: 'Bordspel', en: 'Board game', de: 'Brettspiel', fr: 'Jeu de société', es: 'Juego de mesa', it: 'Gioco da tavolo' } },
    { value: 'Dobbelspel', labels: { nl: 'Dobbelspel', en: 'Dice game', de: 'Würfelspiel', fr: 'Jeu de dés', es: 'Juego de dados', it: 'Gioco di dadi' } },
    { value: 'Kaartspel', labels: { nl: 'Kaartspel', en: 'Card game', de: 'Kartenspiel', fr: 'Jeu de cartes', es: 'Juego de cartas', it: 'Gioco di carte' } },
    { value: 'Overig', labels: { nl: 'Overig', en: 'Other', de: 'Sonstiges', fr: 'Autre', es: 'Otros', it: 'Altro' } },
    { value: 'Spelaccessoire', labels: { nl: 'Spelaccessoire', en: 'Game accessory', de: 'Spielzubehör', fr: 'Accessoire de jeu', es: 'Accesorio de juego', it: 'Accessorio di gioco' } },
    { value: 'Structure Deck', labels: { nl: 'Starterdeck', en: 'Starter deck', de: 'Starterdeck', fr: 'Deck de démarrage', es: 'Mazo inicial', it: 'Mazzo introduttivo' } },
    { value: 'Uitbreiding', labels: { nl: 'Uitbreiding', en: 'Expansion', de: 'Erweiterung', fr: 'Extension', es: 'Expansión', it: 'Espansione' } },
  ];
  const boardGameHeadings = {
    nl: 'Producttype',
    en: 'Product type',
    de: 'Produkttyp',
    fr: 'Type de produit',
    es: 'Tipo de producto',
    it: 'Tipo di prodotto',
  };
  const groupFor = new Map(groups.flatMap(group => group.map(value => [value, group])));
  const splitTypeValues = value => window.lcProductSearchScope?.getScope().allowed?.has(value)
    ? [value] : String(value || '').split(',').map(item => item.trim()).filter(Boolean);
  const getProductScope = (search = window.location.search) =>
    window.lcProductSearchScope?.getScope(search) || { active: false };
  const isPartialProductGroup = (group, scope) => {
    if (!scope.active || scope.baseline) return false;
    const allowed = group.filter(value => scope.allowed.has(value));
    const selected = allowed.filter(value => scope.selected.has(value));
    return selected.length > 0 && selected.length < allowed.length;
  };
  const pokemonLanguage = value => {
    const normalized = String(value || '').trim().toLowerCase();
    if (['english', 'engels', 'en'].includes(normalized)) return 'English';
    if (['japanese', 'japans', 'jp', 'ja'].includes(normalized)) return 'Japanese';
    return null;
  };
  function getPokemonScope(search = window.location.search) {
    const config = document.querySelector('[data-lc-facet-groups]');
    const handle = config?.dataset.lcPokemonHandle || '';
    const params = new URLSearchParams(search);
    const tags = JSON.parse(config?.dataset.lcPokemonTags || 'null') || [];
    const language = handle === 'pokemon-japans' ? 'Japanese'
      : handle === 'pokemon' && tags.some(tag => pokemonLanguage(tag) === 'English') ? 'English'
      : handle === 'pokemon-tcg'
        ? params.getAll('filter.v.option.language').map(pokemonLanguage).find(Boolean)
        : null;
    const active = Boolean(language);
    const allowed = new Set((config?.dataset.lcPokemonSealedAliases || '').split('|').filter(Boolean));
    const allTypes = JSON.parse(config?.dataset.lcPokemonTypes || 'null') || [];
    const sealedTypes = allTypes.filter(value => allowed.has(value.trim().toLowerCase()));
    const selected = new Set(params.getAll(parameter).flatMap(splitTypeValues));
    const baseline = active && (selected.size === 0 || sealedTypes.every(value => selected.has(value)));
    return { active, handle, language: language || null, sealedTypes, baseline };
  }
  function normalizeSearchParams(search) {
    const params = new URLSearchParams(search);
    const raw = params.getAll(parameter);
    const values = raw.flatMap(splitTypeValues);
    const productScope = getProductScope(search);
    if (productScope.active) {
      return window.lcProductSearchScope.normalizeSearchParams(search);
    }
    let expanded = [...new Set(values.flatMap(value => groupFor.get(value) || [value]))];
    const scope = getPokemonScope(search);
    if (scope.active) {
      const allowed = new Set(scope.sealedTypes);
      expanded = expanded.filter(value => allowed.has(value));
      if (!expanded.length) expanded = scope.sealedTypes.length ? scope.sealedTypes : ['__lc_no_sealed_products__'];
    }
    const unchanged = raw.length === expanded.length && raw.every((value, index) => value === expanded[index]);
    if (unchanged) return window.lcProductSearchScope?.normalizeSearchParams(search) ?? search.replace(/^\?/, '');
    params.delete(parameter);
    expanded.forEach(value => params.append(parameter, value));
    params.delete('page');
    return window.lcProductSearchScope?.normalizeSearchParams(params.toString()) ?? params.toString();
  }
  function applyProductScope(list, scope) {
    if (!scope.active) return;
    list.querySelectorAll(`input[type="checkbox"][name="${parameter}"]`).forEach(input => {
      if (!splitTypeValues(input.value).some(value => scope.allowed.has(value))) {
        input.closest('li')?.remove();
        return;
      }
      if (scope.baseline && !input.dataset.lcProductScopeInitialized) {
        input.checked = false;
        input.removeAttribute('checked');
        input.closest('li')?.querySelectorAll('.facet-checkbox, .mobile-facets__label').forEach(label => {
          label.classList.remove('active');
        });
      }
      input.dataset.lcProductScopeInitialized = 'true';
    });
  }
  function syncMissingProductTypes(scope) {
    let hasMissing = false;
    document.querySelectorAll('form[id^="FacetFiltersForm"]').forEach(form => {
      const represented = new Set([...form.querySelectorAll(`input[type="checkbox"][name="${parameter}"]`)]
        .flatMap(input => splitTypeValues(input.value)));
      const missing = new Set(scope.active && !scope.baseline
        ? [...scope.selected].filter(value => !represented.has(value)) : []);
      if (missing.size) hasMissing = true;
      form.querySelectorAll('input[data-lc-missing-search-product-type]').forEach(input => {
        if (missing.has(input.value)) missing.delete(input.value);
        else input.remove();
      });
      missing.forEach(value => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = parameter;
        input.value = value;
        input.dataset.lcMissingSearchProductType = '';
        form.append(input);
      });
    });
    return hasMissing;
  }
  const missingTypeClearDisplays = new WeakMap();
  function syncMissingTypeClearAll(hasMissing) {
    document.querySelectorAll('.active-facets__button-wrapper').forEach(wrapper => {
      const link = wrapper.querySelector('.active-facets__button-remove');
      if (!link) return;
      [[wrapper, 'flex'], [link, 'inline-flex']].forEach(([element, display]) => {
        if (hasMissing && !missingTypeClearDisplays.has(element)) {
          missingTypeClearDisplays.set(element, {
            value: element.style.getPropertyValue('display'),
            priority: element.style.getPropertyPriority('display'),
          });
          element.style.setProperty('display', display, 'important');
          if (element === wrapper) wrapper.dataset.lcMissingSearchTypeClear = '';
        } else if (!hasMissing && missingTypeClearDisplays.has(element)) {
          const previous = missingTypeClearDisplays.get(element);
          if (previous.value) element.style.setProperty('display', previous.value, previous.priority);
          else element.style.removeProperty('display');
          missingTypeClearDisplays.delete(element);
          if (element === wrapper) delete wrapper.dataset.lcMissingSearchTypeClear;
        }
      });
    });
  }
  function applyPokemonScope(list, scope) {
    if (!scope.active) return;
    const allowed = new Set(scope.sealedTypes);
    list.querySelectorAll(`input[type="checkbox"][name="${parameter}"]`).forEach(input => {
      const available = splitTypeValues(input.value).some(value => allowed.has(value));
      if (!available) {
        input.closest('li')?.remove();
        return;
      }
      if (scope.baseline) {
        input.checked = false;
        input.removeAttribute('checked');
        input.closest('li')?.querySelectorAll('.facet-checkbox, .mobile-facets__label').forEach(label => {
          label.classList.remove('active');
        });
      }
    });
  }
  const setText = (element, value) => {
    if (element && element.textContent !== String(value)) element.textContent = value;
  };
  const format = (config, kind, count) =>
    config.dataset[kind + (count === 1 ? 'One' : 'Other')].replace('__COUNT__', count);

  const boardGameLocale = config => config.dataset.locale || document.documentElement.lang.slice(0, 2) || 'nl';
  const boardGameLabel = (type, config) => type.labels[boardGameLocale(config)] || type.labels.en;
  const boardGameValue = (type, config) =>
    boardGameLocale(config) === 'nl' ? type.value : boardGameLabel(type, config);
  const splitValues = value => String(value || '').split(',').map(item => item.trim()).filter(Boolean);

  function setOwnText(element, value) {
    if (!element) return;
    const textNode = [...element.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
    if (textNode) {
      const current = textNode.nodeValue.trim();
      if (current !== value) textNode.nodeValue = textNode.nodeValue.replace(current, value);
    } else {
      element.prepend(document.createTextNode(value));
    }
  }

  function localizeBoardGameHeading(list, config) {
    const details = list.closest('details');
    if (!details) return;
    const heading = config.dataset.lcBoardGameHeading || boardGameHeadings[boardGameLocale(config)] || boardGameHeadings.en;
    setText(list.closest('fieldset')?.querySelector('legend'), heading);
    const summary = details.querySelector('summary');
    const desktopLabel = summary?.querySelector('.facets__label');
    if (desktopLabel) {
      setOwnText(desktopLabel, heading);
    } else {
      setText(summary?.querySelector('div > span:first-child'), heading);
    }
  }

  function renderBoardGameList(list, config) {
    const inputs = [...list.querySelectorAll(`input[type="checkbox"][name="${parameter}"]`)];
    if (!inputs.length) return false;
    inputs.forEach(input => {
      const type = boardGameTypes.find(type => type.value === input.value || Object.values(type.labels).includes(input.value));
      if (!type) return;
      const row = input.closest('li');
      if (!row) return;
      const visibleLabel = boardGameLabel(type, config);
      const label = row.querySelector('label');
      label?.setAttribute('title', visibleLabel);
      row.classList.add('lc-boardgame-type-item');
      label?.classList.add('lc-boardgame-type-label');
      // Keep native values, count, availability and checked state from this response.
      setText(row.querySelector('.facet-checkbox__text-label'), visibleLabel);
      const count = row.querySelector('.lc-facet-count')?.textContent;
      if (count != null) setText(row.querySelector('.lc-facet-accessible'), `${visibleLabel} (${format(config, 'count', Number(count))})`);
    });
    list.classList.add('lc-boardgame-types', 'facets-layout-list--text');
    localizeBoardGameHeading(list, config);
    return true;
  }

  function groupList(list, config, listIndex) {
    const inputs = [...list.querySelectorAll('input[type="checkbox"]')]
      .filter(input => input.name === parameter);
    if (!inputs.length) return;
    if (config.dataset.lcBoardGameTypes === 'true' && renderBoardGameList(list, config, listIndex)) return;
    if (list.dataset.lcGrouped && inputs.every(input => input.lcFacetGrouped)) return;
    list.dataset.lcGrouped = 'true';
    const rows = inputs.map(input => input.closest('li'));
    const focusedInput = inputs.find(input => input === document.activeElement);
    const threshold = rows.findIndex(row => row.classList.contains('show-more-item'));
    const display = list.closest('.parent-display');
    const more = display?.querySelector('show-more-button');
    const expanded = more?.querySelector('.label-show-less:not(.hidden)') !== null && Boolean(more);
    const buckets = new Map();
    inputs.forEach(input => {
      const group = groupFor.get(input.value) || input.lcFacetTypeGroup;
      if (!group) return;
      if (!buckets.has(group[0])) buckets.set(group[0], []);
      buckets.get(group[0]).push(input);
    });
    buckets.forEach((members, canonical) => {
      const productScope = getProductScope();
      if (isPartialProductGroup(groupFor.get(canonical), productScope)) return;
      const input = members.find(member => member === document.activeElement) || members[0];
      const row = input.closest('li');
      const label = row.querySelector('label');
      const sourceCounts = new Map();
      members.forEach(member => {
        if (member.lcFacetTypeCounts) member.lcFacetTypeCounts.forEach((count, value) => sourceCounts.set(value, count));
      });
      members.forEach(member => {
        if (!member.lcFacetTypeCounts) sourceCounts.set(member.value, Number(member.closest('li').querySelector('.lc-facet-count')?.textContent.trim() || 0));
      });
      const count = [...sourceCounts.values()].reduce((sum, value) => sum + value, 0);
      const selected = members.some(member => member.checked);
      const typeGroup = productScope.active
        ? groupFor.get(canonical).filter(value => productScope.allowed.has(value)) : groupFor.get(canonical);
      input.lcFacetTypeGroup = typeGroup;
      input.lcFacetTypeCounts = sourceCounts;
      input.value = typeGroup.join(',');
      input.checked = selected;
      input.disabled = count === 0 && !selected;
      row.querySelectorAll('.facet-checkbox, .mobile-facets__label').forEach(element => {
        element.classList.toggle('active', selected);
        element.classList.toggle('disabled', input.disabled);
      });
      setText(row.querySelector('.facet-checkbox__text-label'), canonical);
      if (label?.hasAttribute('title')) label.setAttribute('title', canonical);
      setText(row.querySelector('.lc-facet-count'), count);
      setText(label?.querySelector('.lc-facet-accessible'), `${canonical} (${format(config, 'count', count)})`);
      members.filter(member => member !== input).forEach(member => member.closest('li').remove());
    });
    inputs.forEach(input => { input.lcFacetGrouped = true; });
    const remaining = [...list.children].filter(row => row.matches('li'));
    remaining.sort((left, right) =>
      (left.querySelector('.facet-checkbox__text-label')?.textContent || '').localeCompare(
        right.querySelector('.facet-checkbox__text-label')?.textContent || '', document.documentElement.lang || undefined,
        { sensitivity: 'base' }
      )
    ).forEach(row => list.append(row));
    if (threshold >= 0) {
      remaining.forEach((row, index) => {
        row.classList.toggle('show-more-item', index >= threshold);
        row.classList.toggle('hidden', index >= threshold && !expanded);
      });
      more?.classList.toggle('hidden', remaining.length <= threshold);
    }
    if (focusedInput?.isConnected && !focusedInput.disabled) focusedInput.focus({ preventScroll: true });
  }

  function updateSummary(list, config) {
    const details = list.closest('details');
    const summary = details?.querySelector('summary');
    if (!summary) return;
    const selected = list.querySelectorAll(`input[name="${parameter}"]:checked`).length;
    const bubble = summary.querySelector('.facets__bubble');
    setText(bubble, selected);
    bubble?.closest('.facets__status')?.classList.toggle('hidden', selected === 0);
    const label = list.closest('fieldset')?.querySelector('legend')?.textContent.trim() ||
      summary.querySelector(':scope > div > span:first-child')?.textContent.trim();
    if (label && summary.hasAttribute('aria-label')) {
      summary.setAttribute('aria-label', `${label} (${format(config, 'selected', selected)})`);
    }
  }

  function updateTypeRemovalLink(link, group, productScope) {
    const url = new URL(productScope.active ? window.location.href : link.href, window.location.href);
    const remaining = url.searchParams.getAll(parameter).flatMap(splitTypeValues)
      .filter(value => !group.includes(value));
    url.searchParams.delete(parameter);
    [...new Set(remaining)].forEach(value => url.searchParams.append(parameter, value));
    url.searchParams.delete('page');
    if (productScope.active) url.search = window.lcProductSearchScope.normalizeSearchParams(url.search);
    const href = url.pathname + url.search + url.hash;
    if (link.getAttribute('href') !== href) link.setAttribute('href', href);
  }

  function groupChips(container, config) {
    const scope = getPokemonScope();
    const productScope = getProductScope();
    if (productScope.active) {
      container.querySelectorAll('template[data-lc-search-product-type-chip]').forEach(template => {
        if (productScope.baseline) template.remove();
        else template.replaceWith(template.content.cloneNode(true));
      });
    }
    const seen = new Set();
    container.querySelectorAll('[data-lc-filter-param]').forEach(link => {
      if (link.dataset.lcFilterParam !== parameter) return;
      if (scope.active && scope.baseline || productScope.active && productScope.baseline) {
        link.closest('facet-remove')?.remove();
        return;
      }
      if (config.dataset.lcBoardGameTypes === 'true') {
        const type = boardGameTypes.find(item => boardGameValue(item, config) === link.dataset.lcFilterValue);
        if (type) setText(link.querySelector('[data-lc-active-facet-label]'), boardGameLabel(type, config));
      }
      const group = groupFor.get(link.dataset.lcFilterValue);
      if (!group || isPartialProductGroup(group, productScope)) {
        if (productScope.active) updateTypeRemovalLink(link, [link.dataset.lcFilterValue], productScope);
        return;
      }
      if (seen.has(group[0])) {
        link.closest('facet-remove').remove();
        return;
      }
      seen.add(group[0]);
      setText(link.querySelector('[data-lc-active-facet-label]'), group[0]);
      updateTypeRemovalLink(link, group, productScope);
    });
  }

  function refresh() {
    const config = document.querySelector('[data-lc-facet-groups]');
    if (!config) return;
    const lists = new Set([...document.querySelectorAll(`input[name="${parameter}"]`)]
      .map(input => input.closest('ul')).filter(Boolean));
    const scope = getPokemonScope();
    const productScope = getProductScope();
    [...lists].forEach((list, index) => {
      applyProductScope(list, productScope);
      applyPokemonScope(list, scope);
      groupList(list, config, index);
      updateSummary(list, config);
    });
    const hasMissingTypes = syncMissingProductTypes(productScope);
    document.querySelectorAll('.active-facets').forEach(container => groupChips(container, config));
    syncMissingTypeClearAll(hasMissingTypes);
  }

  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      refresh();
    });
  };
  window.lcFacetGroups = { refresh, normalizeSearchParams, getPokemonScope };
  const start = () => {
    refresh();
    new MutationObserver(records => {
      if (records.some(record =>
        record.target instanceof Element && record.target.closest('facet-filters-form, .active-facets') ||
        [...record.addedNodes].some(node => node instanceof Element &&
          (node.matches('facet-filters-form, .active-facets') || node.querySelector('facet-filters-form, .active-facets')))
      )) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
    customElements.whenDefined('facet-filters-form').then(() => {
      const search = window.location.search.slice(1);
      const normalized = normalizeSearchParams(search);
      if (normalized === search) return;
      history.replaceState({ ...history.state, searchParams: normalized }, '',
        window.location.pathname + (normalized ? '?' + normalized : '') + window.location.hash);
      customElements.get('facet-filters-form').renderPage(normalized, undefined, false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lichcards-facet-labels"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.lcFacetLabelsLoaded) return;
  window.lcFacetLabelsLoaded = true;

  var lang = (document.documentElement.getAttribute('lang') || 'nl')
    .slice(0, 2)
    .toLowerCase();

  var STANDARD = { en: 'Standard', de: 'Standard', fr: 'Standard', es: 'Estandar', it: 'Standard' }[lang] || 'Standaard';
  var SIGNED = { en: 'Signed', de: 'Signiert', fr: 'Signee', es: 'Firmada', it: 'Firmata' }[lang] || 'Gesigneerd';

  
  var LANGUAGE_NL = {
    English: 'Engels',
    Japanese: 'Japans',
    Spanish: 'Spaans',
    Chinese: 'Chinees',
    German: 'Duits',
    French: 'Frans',
    Italian: 'Italiaans',
    Korean: 'Koreaans',
    Dutch: 'Nederlands'
  };

  var MAP = {
    'Reverse-Holo': 'Reverse holo',
    'Reverse-Holo Normal': 'Reverse holo',
    'Reverse-Holo 1st-Edition': 'Reverse holo, 1st Edition',
    'Foil Normal': 'Foil',
    'Rainbow-Foil Normal': 'Rainbow foil',
    'Cold-Foil Normal': 'Cold foil',
    '1st-Edition': '1st Edition'
  };

  function labelFor(raw) {
    if (raw === 'Normal') return STANDARD;
    if (raw === 'Normal Signed') return STANDARD + ' - ' + SIGNED;
    return MAP[raw] || null;
  }

  
  function isFinishFilter(input) {
    var n = (input.getAttribute('name') || '').toLowerCase();
    if (n.indexOf('option.edition') !== -1) return true;
    if (n.indexOf('option.editie') !== -1) return true;
    if (n.indexOf('filter.p.tag') === 0) return true;
    return false;
  }

  function isLanguageFilter(input) {
    var n = (input.getAttribute('name') || '').toLowerCase();
    return n.indexOf('filter.v.option.language') === 0;
  }

  function sel(id) {
    return window.CSS && CSS.escape ? CSS.escape(id) : id;
  }

  
  function swapText(el, raw, mapped) {
    if (!document.createTreeWalker) return false;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    var changed = false;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.trim();
      if (text === raw || text.indexOf(raw + ' (') === 0) {
        node.nodeValue = node.nodeValue.replace(raw, mapped);
        changed = true;
      }
    }
    return changed;
  }

  function valueLabelForName(name, raw) {
    name = String(name || '').toLowerCase();
    if (lang === 'nl' && name === 'filter.v.option.language') return LANGUAGE_NL[raw] || null;
    if (name === 'filter.v.option.edition' || name === 'filter.v.option.editie' || name === 'filter.p.tag') {
      return labelFor(raw);
    }
    return null;
  }

  function groupLabelForName(name) {
    if (lang !== 'nl') return null;
    var isSearch = document.body && document.body.classList.contains('template-search');
    var labels = {
      'filter.v.option.language': 'Taal',
      'filter.p.m.custom.expansion': 'Set',
      'filter.v.option.edition': 'Uitvoering',
      'filter.v.option.condition': 'Conditie'
    };
    if (isSearch) {
      labels['filter.p.m.custom.taal'] = 'Taal bordspel';
      labels['filter.p.m.custom.spelsoort'] = 'Spelgenre';
    }
    return labels[name] || null;
  }

  function translateChipLabel(host, name, raw) {
    if (!raw) return;
    var mapped = valueLabelForName(name, raw);
    var group = groupLabelForName(name);
    if (!mapped && !group) return;
    var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var text = node.nodeValue.trim();
      var next = null;
      if (text === raw) {
        next = mapped || raw;
      } else if (text.slice(-raw.length - 2) === ': ' + raw) {
        var prefix = text.slice(0, -raw.length - 2);
        next = (group || prefix) + ': ' + (mapped || raw);
      }
      if (next !== null && next !== text) node.nodeValue = node.nodeValue.replace(text, next);
    }
  }

  function translateActiveChips() {
    if (!document.createTreeWalker) return;
    var canReadURL = window.URL && window.URLSearchParams;
    var selected = canReadURL ? new URLSearchParams(window.location.search) : null;
    var chips = document.querySelectorAll('.active-facets__button-inner');
    for (var i = 0; i < chips.length; i++) {
      var chip = chips[i];
      var link = chip.closest('a[href]');
      if (!link) continue;
      var host = chip.querySelector('[data-lc-active-facet-label]') || chip;
      var nativeName = link.getAttribute('data-lc-filter-param');
      var nativeValue = link.getAttribute('data-lc-filter-value');
      if (nativeName !== null && nativeValue !== null) {
        translateChipLabel(host, nativeName, nativeValue);
        continue;
      }
      if (!selected) continue;
      var remaining;
      try {
        remaining = new URL(link.getAttribute('href'), window.location.href).searchParams;
      } catch (error) {
        continue;
      }
      selected.forEach(function (raw, name) {
        if (name.indexOf('filter.') !== 0 || remaining.getAll(name).indexOf(raw) !== -1) return;
        translateChipLabel(host, name, raw);
      });
    }
  }

  function apply() {
    var inputs = document.querySelectorAll('input[name^="filter."]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];

      var raw = (input.value || '').trim();
      var languageFilter = lang === 'nl' && isLanguageFilter(input);
      if (!languageFilter && !isFinishFilter(input)) continue;

      var mapped = languageFilter ? LANGUAGE_NL[raw] : labelFor(raw);
      if (!mapped || mapped === raw) continue;

      var lab = null;
      if (input.id) lab = document.querySelector('label[for="' + sel(input.id) + '"]');
      if (!lab && input.closest) lab = input.closest('label');
      if (!lab) continue;

      if (swapText(lab, raw, mapped)) {
        lab.setAttribute('title', raw);
      }
      input.setAttribute('data-lc-facet-done', '1');
    }

    translateActiveChips();
  }

  function facetTextChanged(target) {
    var host = target && target.closest && target.closest('.facet-checkbox__text, .checkbox__label-text');
    var label = host && host.closest('label');
    if (!label) return false;
    var input = label.querySelector('input[name^="filter."]');
    if (!input && label.hasAttribute('for')) input = document.getElementById(label.getAttribute('for'));
    return !!(input && input.matches('input[name^="filter."]'));
  }

  function relevantFacetMutations(records) {
    var selector = 'input[name^="filter."], .active-facets__button-inner, [data-lc-active-facet-label]';
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target && target.closest('.lc-facet-visual')) continue;
      if (record.type === 'childList' && record.addedNodes.length && !record.removedNodes.length) {
        var onlyCues = true;
        for (var j = 0; j < record.addedNodes.length; j++) {
          var cue = record.addedNodes[j];
          if (cue.nodeType !== 1 || !cue.matches('.lc-facet-visual')) onlyCues = false;
        }
        if (onlyCues) continue;
      }
      if (target && target.closest('.active-facets__button-inner, [data-lc-active-facet-label]')) return true;
      if (facetTextChanged(target)) return true;
      if (record.type === 'attributes' && target) {
        if (target.matches('input[name^="filter."]')) return true;
        if (target.querySelector('.active-facets__button-inner, [data-lc-active-facet-label]')) return true;
        if (target.matches('label[for]')) {
          var input = document.getElementById(target.getAttribute('for'));
          if (input && input.matches('input[name^="filter."]')) return true;
        }
      }
      for (var k = 0; k < record.addedNodes.length; k++) {
        var node = record.addedNodes[k];
        if (node.nodeType !== 1) continue;
        if (node.matches(selector) || node.querySelector(selector)) return true;
        if (facetTextChanged(node) || facetTextChanged(node.querySelector('.facet-checkbox__text, .checkbox__label-text'))) return true;
      }
    }
    return false;
  }

  function boot() {
    apply();
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    var observer = new MutationObserver(function (records) {
      if (queued || !relevantFacetMutations(records)) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['value', 'name', 'id', 'for', 'data-lc-filter-param', 'data-lc-filter-value'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  'use strict';

  if (window.lcFacetVisualsLoaded) return;
  window.lcFacetVisualsLoaded = true;

  /* Lichcards 04-09-2026 (audit punt 7): SVG-vlaggen in plaats van vlag-emoji.
     Windows heeft geen vlag-emoji; Chrome en Edge op Windows toonden "GB", "JP" als losse letters. */
  var LANGUAGE_FLAGS = {
    gb: '<svg class="lc-flag lc-flag--gb" viewBox="0 0 60 40" aria-hidden="true" focusable="false"><rect width="60" height="40" fill="#012169"/><path d="M0 0l60 40M60 0L0 40" stroke="#fff" stroke-width="8"/><path d="M0 0l60 40M60 0L0 40" stroke="#C8102E" stroke-width="2.6"/><path d="M30 0v40M0 20h60" stroke="#fff" stroke-width="13"/><path d="M30 0v40M0 20h60" stroke="#C8102E" stroke-width="8"/></svg>',
    jp: '<svg class="lc-flag lc-flag--jp" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><circle cx="15" cy="10" r="6" fill="#BC002D"/></svg>',
    de: '<svg class="lc-flag lc-flag--de" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#000"/><rect y="6.67" width="30" height="6.67" fill="#DD0000"/><rect y="13.33" width="30" height="6.67" fill="#FFCE00"/></svg>',
    fr: '<svg class="lc-flag lc-flag--fr" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><rect width="10" height="20" fill="#0055A4"/><rect x="20" width="10" height="20" fill="#EF4135"/></svg>',
    it: '<svg class="lc-flag lc-flag--it" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><rect width="10" height="20" fill="#009246"/><rect x="20" width="10" height="20" fill="#CE2B37"/></svg>',
    es: '<svg class="lc-flag lc-flag--es" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#AA151B"/><rect y="5" width="30" height="10" fill="#F1BF00"/></svg>',
    pt: '<svg class="lc-flag lc-flag--pt" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#FF0000"/><rect width="12" height="20" fill="#006600"/><circle cx="12" cy="10" r="3.8" fill="#FFE800"/><circle cx="12" cy="10" r="2.1" fill="#fff" stroke="#FF0000" stroke-width=".9"/></svg>',
    kr: '<svg class="lc-flag lc-flag--kr" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><circle cx="15" cy="10" r="5" fill="#CD2E3A"/><path d="M10 10a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 0 5 0 5 5 0 0 1-10 0z" fill="#0047A0"/><g fill="#000"><rect x="3" y="3" width="4.5" height="1"/><rect x="3" y="4.8" width="4.5" height="1"/><rect x="3" y="6.6" width="4.5" height="1"/><rect x="22.5" y="12.4" width="4.5" height="1"/><rect x="22.5" y="14.2" width="4.5" height="1"/><rect x="22.5" y="16" width="4.5" height="1"/><rect x="22.5" y="3" width="4.5" height="1"/><rect x="22.5" y="4.8" width="2" height="1"/><rect x="25" y="4.8" width="2" height="1"/><rect x="22.5" y="6.6" width="4.5" height="1"/><rect x="3" y="12.4" width="2" height="1"/><rect x="5.5" y="12.4" width="2" height="1"/><rect x="3" y="14.2" width="4.5" height="1"/><rect x="3" y="16" width="2" height="1"/><rect x="5.5" y="16" width="2" height="1"/></g></svg>',
    cn: '<svg class="lc-flag lc-flag--cn" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#DE2910"/><path fill="#FFDE00" d="M6 3l1.2 3.6h3.8l-3 2.2 1.1 3.6L6 10.2 2.9 12.4 4 8.8 1 6.6h3.8z"/><g fill="#FFDE00"><circle cx="12.5" cy="3" r=".9"/><circle cx="14.5" cy="5.6" r=".9"/><circle cx="14.5" cy="9.2" r=".9"/><circle cx="12.5" cy="12" r=".9"/></g></svg>',
    tw: '<svg class="lc-flag lc-flag--tw" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#FE0000"/><rect width="15" height="10" fill="#000095"/><circle cx="7.5" cy="5" r="2.6" fill="#fff"/><circle cx="7.5" cy="5" r="1.9" fill="#000095"/><circle cx="7.5" cy="5" r="1.5" fill="#fff"/></svg>',
    nl: '<svg class="lc-flag lc-flag--nl" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#AE1C28"/><rect y="6.67" width="30" height="6.67" fill="#fff"/><rect y="13.33" width="30" height="6.67" fill="#21468B"/></svg>',
    cz: '<svg class="lc-flag lc-flag--cz" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><rect y="10" width="30" height="10" fill="#D7141A"/><path d="M0 0l15 10L0 20z" fill="#11457E"/></svg>',
    ru: '<svg class="lc-flag lc-flag--ru" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><rect y="6.67" width="30" height="6.67" fill="#0039A6"/><rect y="13.33" width="30" height="6.67" fill="#D52B1E"/></svg>',
    id: '<svg class="lc-flag lc-flag--id" viewBox="0 0 30 20" aria-hidden="true" focusable="false"><rect width="30" height="20" fill="#fff"/><rect width="30" height="10" fill="#CE1126"/></svg>',
    globe: '<svg class="lc-flag lc-flag--globe" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="8" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M2 10h16M10 2c3.2 3 3.2 13 0 16M10 2c-3.2 3-3.2 13 0 16M4 5.5h12M4 14.5h12" fill="none" stroke="currentColor" stroke-width="1.1"/></svg>',
  };
  var LANGUAGE_ICONS = {};
  (function () {
    var keys = {
      gb: ['english', 'engels', 'englisch', 'anglais', 'ingles', 'inglese'],
      jp: ['japanese', 'japans', 'japanisch', 'japonais', 'japones', 'giapponese'],
      de: ['german', 'duits', 'deutsch', 'allemand', 'aleman', 'tedesco'],
      fr: ['french', 'frans', 'franzosisch', 'francais', 'frances', 'francese'],
      it: ['italian', 'italiaans', 'italienisch', 'italien', 'italiano'],
      es: ['spanish', 'spaans', 'spanisch', 'espagnol', 'espanol', 'spagnolo'],
      pt: ['portuguese', 'portugees', 'portugiesisch', 'portugais', 'portugues', 'portoghese'],
      kr: ['korean', 'koreaans', 'koreanisch', 'coreen', 'coreano'],
      cn: ['chinese', 'chinees', 'chinesisch', 'chinois', 'chino', 'cinese', 'simplified-chinese', 'vereenvoudigd-chinees'],
      tw: ['traditional-chinese', 'traditioneel-chinees'],
      nl: ['dutch', 'nederlands', 'niederlandisch', 'neerlandais', 'neerlandes', 'olandese'],
      cz: ['czech', 'tsjechisch', 'tschechisch', 'tcheque', 'checo', 'ceco'],
      ru: ['russian', 'russisch', 'russe', 'ruso', 'russo'],
      id: ['indonesian', 'indonesisch', 'indonesien', 'indonesio', 'indonesiano'],
      globe: ['multilingual', 'meertalig', 'mehrsprachig', 'multilingue', 'multilingue', 'multilingua'],
    };
    Object.keys(keys).forEach(function (flag) {
      keys[flag].forEach(function (name) { LANGUAGE_ICONS[name] = LANGUAGE_FLAGS[flag]; });
    });
  })();

  var CONDITION_TONES = {
    mint: 'mint',
    'near-mint': 'near-mint',
    'bijna-nieuw': 'near-mint',
    excellent: 'excellent',
    uitstekend: 'excellent',
    good: 'lightly-played',
    'lightly-played': 'lightly-played',
    'licht-gespeeld': 'lightly-played',
    played: 'moderately-played',
    'moderately-played': 'moderately-played',
    'matig-gespeeld': 'moderately-played',
    'heavily-played': 'heavily-played',
    'zwaar-gespeeld': 'heavily-played',
    poor: 'damaged',
    damaged: 'damaged',
    beschadigd: 'damaged'
  };

  function key(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function kindFor(input) {
    var name = (input.getAttribute('name') || '').toLowerCase();
    if (
      name.indexOf('filter.v.option.language') === 0 ||
      name.indexOf('filter.p.m.custom.taal') === 0
    ) return 'language';
    if (
      name.indexOf('filter.v.option.condition') === 0 ||
      name.indexOf('filter.v.option.conditie') === 0 ||
      name.indexOf('filter.p.m.custom.condition') === 0 ||
      name.indexOf('filter.p.m.custom.conditie') === 0
    ) return 'condition';
    return '';
  }

  function labelFor(input) {
    if (!input.id) return input.closest ? input.closest('label') : null;
    var escaped = window.CSS && CSS.escape ? CSS.escape(input.id) : input.id;
    return document.querySelector('label[for="' + escaped + '"]');
  }

  function insertCue(input) {
    var kind = kindFor(input);
    if (!kind) return;

    var label = labelFor(input);
    var host = label && label.querySelector('.facet-checkbox__text, .checkbox__label-text');
    if (!host || host.querySelector('.lc-facet-visual')) return;

    var raw = (input.value || '').trim();
    var cue = document.createElement('span');
    cue.className = 'lc-facet-visual lc-facet-visual--' + kind;
    cue.setAttribute('aria-hidden', 'true');

    if (kind === 'language') {
      cue.innerHTML = LANGUAGE_ICONS[key(raw)] || LANGUAGE_FLAGS.globe;
      cue.setAttribute('data-tone', 'language');
    } else {
      var tone = CONDITION_TONES[key(raw)] || 'neutral';
      cue.textContent = '●';
      cue.setAttribute('data-tone', tone);
      label.setAttribute('data-lc-condition', tone);
    }

    host.insertBefore(cue, host.firstChild);
    label.classList.add('lc-facet-option--' + kind);
    input.setAttribute('data-lc-visual-done', '1');
  }

  function decorateInputs() {
    var inputs = document.querySelectorAll('input[name^="filter."]');
    for (var i = 0; i < inputs.length; i++) insertCue(inputs[i]);
  }

  function relevantVisualMutations(records) {
    var selector = 'input[name^="filter."]';
    var needsScan = false;
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target && target.closest('.lc-facet-visual')) continue;
      if (record.type === 'attributes' && target) {
        var input = target.matches(selector) ? target : null;
        if (!input && target.matches('label[for]')) input = document.getElementById(target.getAttribute('for'));
        if (input && input.matches(selector)) {
          var label = labelFor(input);
          var cue = label && label.querySelector('.lc-facet-visual');
          if (cue) cue.remove();
          needsScan = true;
        }
      }
      var host = target && target.closest('.facet-checkbox__text, .checkbox__label-text');
      var label = host && host.closest('label');
      if (label) {
        var input = label.querySelector(selector);
        if (!input && label.hasAttribute('for')) input = document.getElementById(label.getAttribute('for'));
        if (input && input.matches(selector) && !host.querySelector('.lc-facet-visual')) needsScan = true;
      }
      for (var j = 0; j < record.addedNodes.length; j++) {
        var node = record.addedNodes[j];
        if (node.nodeType !== 1 || node.matches('.lc-facet-visual')) continue;
        if (node.matches(selector) || node.querySelector(selector)) needsScan = true;
        var addedHost = node.matches('.facet-checkbox__text, .checkbox__label-text') ? node : node.querySelector('.facet-checkbox__text, .checkbox__label-text');
        if (addedHost) {
          var addedLabel = addedHost.closest('label');
          if (addedLabel && (addedLabel.querySelector(selector) || document.getElementById(addedLabel.getAttribute('for'))?.matches(selector))) needsScan = true;
        }
      }
    }
    return needsScan;
  }

  function boot() {
    decorateInputs();
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    new MutationObserver(function (records) {
      if (queued || !relevantVisualMutations(records)) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        decorateInputs();
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'name', 'id', 'for'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
